export default "__VITE_ASSET__33f4b7b1__"